import moment from "moment";
import { Button, Modal } from "react-bootstrap";

export const ModalReloadPrev = (props: any) => {
  return (
    <>
      <Modal as={Modal.Dialog} centered show={props.show} onHide={props.close}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          {props.Message}
          {(() => {
            if (typeof props.ListChange != 'undefined'  && props.ListChange.length>0) {
              return(
                <><hr /><Modal.Title className='h6'>{props.MessageChange}</Modal.Title><hr /></>
                )
            }

        })()}

        </Modal.Body>
        <Modal.Footer>
          {props.children}
          <Button
          disabled={props.isLoading || false}
          variant='link'
          className='text-gray ms-auto'
          onClick={props.close}>
          {props.cancel}
        </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
